'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svgIcon = require('../../../svg-icon');

var _calendar = require('./calendar');

var _calendar2 = _interopRequireDefault(_calendar);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NonCoreRightSection = function NonCoreRightSection(_ref) {
    var profileUrl = _ref.profileUrl,
        hasBookings = _ref.hasBookings,
        availabilities = _ref.availabilities;
    return hasBookings && availabilities && availabilities.length && _react2.default.createElement(_calendar2.default, {
        availabilities: availabilities,
        profileUrl: profileUrl
    }) || _react2.default.createElement(
        'div',
        { className: _style2.default.nonCoreTextWrapper },
        _react2.default.createElement(
            'p',
            { className: _style2.default.nonCoreText },
            'Vitality Recognised Consultant'
        ),
        _react2.default.createElement(
            'div',
            {
                className: _style2.default.requestAppointmentSpecialistButton + ' ' + _style2.default.requestAppointmentSpecialistButtonViewProfile },
            _react2.default.createElement(
                'a',
                {
                    href: profileUrl,
                    className: _style2.default.nonCoreButton + ' btn solid'
                },
                _react2.default.createElement(_svgIcon.SvgIcon, {
                    className: _style2.default.nonCoreIcon,
                    icon: 'go_to_arrow'
                }),
                _react2.default.createElement(
                    'span',
                    null,
                    'View Profile'
                )
            )
        )
    );
};

NonCoreRightSection.defaultProps = {
    profileUrl: '',
    hasBookings: false,
    availabilities: []
};

NonCoreRightSection.displayName = 'NonCoreRightSection';

exports.default = NonCoreRightSection;


// WEBPACK FOOTER //
// ./components/search-results/lib/components/non-core-right-section.js